/*****************************************
 * ПОЛЬЗОВАТЕЛЬСКИЕ НАСТРОЙКИ ИНТЕРФЕЙСА *
 *****************************************/

const systemSettings = {
    cacheToggles: false,
    cacheDictionaries: false,
    cacheLifetime: 3600000,
    isLoadingInProgress: false
};

const modifySetting = function (name, value) {
    systemSettings[name] = value;
};

const getUserSettings = function (user) {
    const settingsObj = webix.storage.local.get("settings");
    let returnObj = {};
    if (settingsObj && settingsObj[user.login]) {
        returnObj = settingsObj[user.login];
    } else {
        returnObj = systemSettings;
    }
    return returnObj;
};

const setUserSettings = function (user) {
    const userSettings = {};
    userSettings[user.login] = systemSettings;
    webix.storage.local.put("settings", userSettings);
};

const getCurrentSection = function () {
    return window.location.hash.split("/")[2];
};

const getStartPageForRole = function (role) {
    if (role === "superadmin" || role === "admin" || role === "enterprise_admin") {
        return "/app/mainEnterprise";
    }
    if (role === "transporter" || role === "user") {
        return "/app/reportsLoadTable";
    }
    return "/app/default";
};

const setStackLoadInProgress = function (value) {
    systemSettings.isLoadingInProgress = value;
};

const getStackLoadStatus = function () {
    return systemSettings.isLoadingInProgress;
};

const getCalculatedTask = function (task) {
    const newTask = webix.copy(task);
    let isTaskOk = true;
    let unifier = "&";
    if (!newTask.field.filters) {
        newTask.field.filters = "";
        unifier = "?";
    }
    for (let j = 0; j < newTask.field.urlParams.length; j++) {
        const param = newTask.field.urlParams[j];
        let paramValue;
        if (typeof param.getValue === "function") {
            paramValue = param.getValue();
        } else {
            paramValue = param.value;
        }
        if (param.required && !paramValue && paramValue === '')
            isTaskOk = false;
        newTask.field.filters += unifier + param.name + "=" + paramValue;
    }
    return isTaskOk ? newTask : isTaskOk;
};

const convertFiltersToQuery = function (filters, isFirst) {
    let custFilter = "";
    if (webix.isArray(filters)) {
        filters.forEach(function (filter, index) {
            if (index === 0 && isFirst) {
                custFilter += "?" + filter.operator + "[" + filter.name + "]=" + filter.value;
            } else {
                custFilter += "&" + filter.operator + "[" + filter.name + "]=" + filter.value;
            }
        });
    } else if (filters) {
        custFilter = filters;
    }
    return custFilter;
};

const generateHexId = function () {
    const arSymbols = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    let output = "";
    for (let i = 0; i < 16; i++) {
        output += arSymbols[Math.floor(Math.random() * 16)];
    }
    return output;
};

const parseFunction = function (str) {
    const fn_body_idx = str.indexOf('{'),
        fn_body = str.substring(fn_body_idx + 1, str.lastIndexOf('}')),
        fn_declare = str.substring(0, fn_body_idx),
        fn_params = fn_declare.substring(fn_declare.indexOf('(') + 1, fn_declare.lastIndexOf(')')),
        args = fn_params.split(',');

    args.push(fn_body);

    function Fn() {
        return Function.apply(this, args);
    }
    Fn.prototype = Function.prototype;
    return new Fn();
};

export default {
    modifySetting,
    getUserSettings,
    setUserSettings,
    convertFiltersToQuery,
    getCurrentSection,
    getStartPageForRole,
    setStackLoadInProgress,
    getStackLoadStatus,
    getCalculatedTask,
    generateHexId,
    parseFunction
};
